import { render } from "./SetMigracaoBolsas.vue?vue&type=template&id=f159afa8"
import script from "./SetMigracaoBolsas.vue?vue&type=script&lang=js"
export * from "./SetMigracaoBolsas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__